module.exports = __webpack_public_path__ + "static/img/mdi-settings-box.273140d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/mdi-settings-box.jpg
// module id = 94gk
// module chunks = 1